"use client";

import { Search, AlertTriangle, TrendingUp, Zap } from "lucide-react";
import { GroundingSearchKPIHeaderProps } from "./types";
import { cn } from "@ui/lib";

export function GroundingSearchKPIHeader({ kpis, className }: GroundingSearchKPIHeaderProps) {
  const percentRanked = kpis.totalSearches > 0
    ? Math.round((kpis.rankedSearches / kpis.totalSearches) * 100)
    : 0;

  return (
    <div className={cn('grid grid-cols-2 md:grid-cols-4 gap-4', className)}>
      {/* Total Searches */}
      <div className="bg-blue-50 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Search className="h-5 w-5 text-blue-600" />
          <span className="text-xs font-medium text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">
            Total
          </span>
        </div>
        <p className="text-2xl font-bold text-blue-900">{kpis.totalSearches}</p>
        <p className="text-sm text-blue-700">Searches Analyzed</p>
      </div>

      {/* Ranked Percentage */}
      <div className="bg-green-50 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <TrendingUp className="h-5 w-5 text-green-600" />
          <span className="text-xs font-medium text-green-600 bg-green-100 px-2 py-0.5 rounded-full">
            {percentRanked}%
          </span>
        </div>
        <p className="text-2xl font-bold text-green-900">{kpis.rankedSearches}</p>
        <p className="text-sm text-green-700">Brand Rankings</p>
      </div>

      {/* Gap Opportunities */}
      <div className="bg-orange-50 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <AlertTriangle className="h-5 w-5 text-orange-600" />
          <span className="text-xs font-medium text-orange-600 bg-orange-100 px-2 py-0.5 rounded-full">
            Gaps
          </span>
        </div>
        <p className="text-2xl font-bold text-orange-900">{kpis.totalGaps}</p>
        <p className="text-sm text-orange-700">Opportunities</p>
      </div>

      {/* High Impact Gaps */}
      <div className="bg-red-50 rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <Zap className="h-5 w-5 text-red-600" />
          <span className="text-xs font-medium text-red-600 bg-red-100 px-2 py-0.5 rounded-full">
            Priority
          </span>
        </div>
        <p className="text-2xl font-bold text-red-900">{kpis.highImpactGaps}</p>
        <p className="text-sm text-red-700">High Impact</p>
      </div>
    </div>
  );
}


